import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'

import { Button, ButtonOutline } from '../utils/styles'

const NotFoundPage = () =>
  <div
    css={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '40px 15px',
    }}
  >
    <Helmet>
      <title>404 Page Not Found – Patrícia Marques</title>
      <meta name="descritpion" value="I'm sorry but the page you're looking for is not there." />
    </Helmet>
    <h1>Page not found</h1>
    <p>I'm sorry. The page you're looking for has either been moved, deleted or has never existed. Use the links below to go somewhere nicer.</p>
    <Link to="portfolio" className={Button}>Portfolio</Link>
    <Link to="/" className={ButtonOutline}>Home</Link>
  </div>

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/404.js